import { render, staticRenderFns } from "./SideQuestsDrawer.vue?vue&type=template&id=bdbf936a&scoped=true"
import script from "./SideQuestsDrawer.vue?vue&type=script&lang=js"
export * from "./SideQuestsDrawer.vue?vue&type=script&lang=js"
import style0 from "./SideQuestsDrawer.vue?vue&type=style&index=0&id=bdbf936a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbf936a",
  null
  
)

export default component.exports